import { z } from 'zod';

export const CountSheetInstrumentDtoSchema = z.object({
  catalogItemId: z.string(),
  expectedQuantity: z.number().min(1),
  displayName: z.string().optional(),
  group: z.string().nullable().optional(),
  set: z.string().nullable().optional(),
  order: z.number().min(1).nullable().optional(),
  notes: z.string().max(1000).nullable().optional(),
  instrumentTaxonomyClassId: z.number().nullable().optional(),
  instrumentTaxonomyClassName: z.string().nullable().optional(),
  instrumentTaxonomyCategoryName: z.string().nullable().optional(),
  productNumber: z.string().nullable().optional(),
});
export type CountSheetInstrumentDto = z.infer<typeof CountSheetInstrumentDtoSchema>;

export const CountSheetResponseDtoSchema = z.object({
  id: z.string(),
  trayId: z.string(),
  trayName: z.string(),
  productNumber: z.string().nullable(),
  createdAt: z.string(),
  updatedAt: z.string(),
  instruments: z.array(CountSheetInstrumentDtoSchema),
});
export type CountSheetResponseDto = z.infer<typeof CountSheetResponseDtoSchema>;

export const CountSheetResponseDtoArraySchema = z.array(CountSheetResponseDtoSchema);

export interface CreateCountSheetDto {
  trayId: string;
  trayName: string;
  instruments: CountSheetInstrumentDto[];
}

export interface ReplaceCountSheetDto {
  trayName: string;
  instruments: CountSheetInstrumentDto[];
}

export const PaginatedCountSheetResponseDtoSchema = z.object({
  data: z.array(CountSheetResponseDtoSchema),
  total: z.number(),
  page: z.number(),
  limit: z.number(),
});
export type PaginatedCountSheetResponseDto = z.infer<typeof PaginatedCountSheetResponseDtoSchema>;

export interface CountSheetListQueryParams {
  page: number;
  limit: number;
  search?: string;
}
